import first from './assets/first.png';
import second from './assets/second.png';
import third from './assets/third.png';
import fourth from './assets/fourth.png';

export const BLOCK_SOURCES = [first, second, third, fourth];

export const BLOCK_WIDTH = 124;
export const BLOCK_HEIGHT = 130;
export const GAP = 8;
export const BLOCK_LAST_INDEX = 3;
